import { UI_SET_LOADER, SET_UI_PROPERTY, GET_MARKDOWN_FILE } from 'store/actions/ui';

export default {
  [UI_SET_LOADER]: ({ commit }, loading) => {
    commit(UI_SET_LOADER, loading);
  },

  [SET_UI_PROPERTY]: ({ commit }, { field, value }) =>
    commit(SET_UI_PROPERTY, {
      field,
      value
    }),

  [GET_MARKDOWN_FILE]: ({ commit, getters }, { file, field }) =>
    // eslint-disable-next-line no-unused-vars
    new Promise((resolve, reject) => {
      if (!getters.dataUI(field)) {
        commit(SET_UI_PROPERTY, {
          field,
          value: file
        });
        resolve();
      } else {
        resolve();
      }
    })
};
